{
  "name": "@ld.consumer-portal/source",
  "version": "2026-10-16",
  "license": "MIT",
  "packageManager": "npm@10.9.2",
  "scripts": {
    "prepare": "husky",
    "clean:node_modules": "node -e \"const fs=require('node:fs');fs.rmSync('node_modules',{recursive:true,force:true});\"",
    "clean": "npm run clean:node_modules",
    "start": "nx serve consumer-portal -c dv1",
    "start:local-dv1": "nx serve consumer-portal -c local-dv1",
    "start:local-qa1": "nx serve consumer-portal -c local-qa1",
    "start:mobile:dv1": "nx serve consumer-portal -c dv1 --host 0.0.0.0 --port 4201",
    "start:mobile:qa1": "nx serve consumer-portal -c qa1 --host 0.0.0.0 --port 4201",
    "start:dv1": "nx serve consumer-portal -c dv1",
    "start:qa1": "nx serve consumer-portal -c qa1",
    "start:sg1": "nx serve consumer-portal -c sg1",
    "start:prod": "nx serve consumer-portal -c rprd",
    "build": "nx build",
    "test": "nx run-many -t test",
    "lint": "nx run-many -t lint",
    "e2e": "nx e2e consumer-portal-e2e",
    "convert-svg": "tsx scripts/convert-svg-to-data-uri.ts",
    "update-data-uri-exports": "tsx scripts/update-data-uri-exports.ts",
    "generate:routes": "tsx scripts/generate-route-map.ts",
    "generate:api-catalog": "tsx scripts/generate-api-catalog.ts",
    "generate:models": "tsx scripts/generate-models-index.ts",
    "generate:docs": "npm run generate:routes && npm run generate:api-catalog && npm run generate:models && npm run generate:component-docs && npm run generate:dep-graph",
    "generate:component-docs": "tsx scripts/generate-component-docs.ts",
    "generate:dep-graph": "tsx scripts/generate-dep-graph.ts",
    "start:admin": "nx serve admin-tool",
    "build:admin": "nx build admin-tool",
    "cap:sync": "npx cap sync",
    "cap:sync:ios": "npx cap sync ios && node scripts/patch-ios-local-plugins.js",
    "cap:sync:android": "npx cap sync android",
    "cap:copy": "npx cap copy",
    "cap:copy:ios": "npx cap copy ios",
    "cap:copy:android": "npx cap copy android",
    "cap:open:ios": "npx cap open ios",
    "cap:open:android": "npx cap open android",
    "cap:run:ios": "npx cap run ios",
    "cap:run:android": "npx cap run android",
    "cap:run:android:live:dv1": "npx cross-env CAPACITOR_SERVER_URL=http://10.0.2.2:4201 npx cap run android --flavor dev",
    "cap:run:android:live:qa1": "npx cross-env CAPACITOR_SERVER_URL=http://10.0.2.2:4201 npx cap run android --flavor qa",
    "cap:run:android:dv1": "nx build consumer-portal -c dv1 && npx cap sync android && npx cap run android --flavor dev",
    "cap:run:android:qa1": "nx build consumer-portal -c qa1 && npx cap sync android && npx cap run android --flavor qa",
    "cap:run:android:sg1": "nx build consumer-portal -c sg1 && npx cap sync android && npx cap run android --flavor uat",
    "cap:run:android:prod": "nx build consumer-portal -c production && npx cap sync android && npx cap run android --flavor prod",
    "cap:build:ios": "npx cap build ios",
    "cap:build:android": "npx cap build android",
    "cap:build:android:dv1": "nx build consumer-portal -c dv1 && npx cap sync android && npx cap build android --flavor dev",
    "cap:build:android:qa1": "nx build consumer-portal -c qa1 && npx cap sync android && npx cap build android --flavor qa",
    "cap:build:android:sg1": "nx build consumer-portal -c sg1 && npx cap sync android && npx cap build android --flavor uat",
    "cap:build:android:prod": "nx build consumer-portal -c production && npx cap sync android && npx cap build android --flavor prod",
    "generate:screenshot-manifest": "tsx scripts/generate-screenshot-manifest.ts",
    "prebuild:dv1": "npm run generate:screenshot-manifest",
    "build:dv1": "nx build consumer-portal -c dv1",
    "screenshots": "cd apps/consumer-portal-e2e && npx playwright test src/routes src/purchase-application src/refinance-application --project=chromium && cd ../.. && tsx scripts/screenshot-analysis.ts",
    "screenshots:interactions": "cd apps/consumer-portal-e2e && npx playwright test src/interactions --project=chromium",
    "screenshots:capture": "cd apps/consumer-portal-e2e && npx playwright test src/routes src/purchase-application src/refinance-application --project=chromium",
    "screenshots:routes": "cd apps/consumer-portal-e2e && npx playwright test src/routes/all-viewports.spec.ts --project=chromium",
    "screenshots:wizards": "cd apps/consumer-portal-e2e && npx playwright test src/purchase-application src/refinance-application --project=chromium",
    "screenshots:failed": "cd apps/consumer-portal-e2e && npx playwright test --last-failed --project=chromium",
    "screenshots:report": "cd apps/consumer-portal-e2e && npx playwright show-report ../../dist/.playwright/apps/consumer-portal-e2e/playwright-report",
    "screenshots:compare": "tsx scripts/screenshot-analysis.ts --compare",
    "screenshots:diagram": "tsx scripts/screenshot-analysis.ts --diagram",
    "screenshots:analyze": "tsx scripts/screenshot-analysis.ts",
    "screenshots:jv-origination": "cd apps/consumer-portal-e2e && npx playwright test src/routes/jv-origination-routes.spec.ts --project=chromium",
    "screenshots:regression": "cd apps/consumer-portal-e2e && npx playwright test src/regression --project=chromium",
    "e2e:regression": "cd apps/consumer-portal-e2e && npx playwright test src/regression",
    "e2e:regression:headed": "cd apps/consumer-portal-e2e && npx playwright test src/regression --headed",
    "e2e:regression:paperless": "cd apps/consumer-portal-e2e && npx playwright test src/regression/paperless --project=chromium",
    "e2e:regression:mfa": "cd apps/consumer-portal-e2e && npx playwright test src/regression/mfa --project=chromium",
    "e2e:regression:faq": "cd apps/consumer-portal-e2e && npx playwright test src/regression/faq --project=chromium",
    "e2e:regression:smc": "cd apps/consumer-portal-e2e && npx playwright test src/regression/smc --project=chromium",
    "e2e:regression:dashboard": "cd apps/consumer-portal-e2e && npx playwright test src/regression/dashboard --project=chromium",
    "validate:i18n": "tsx scripts/validate-translations.ts",
    "validate:design-system": "tsx scripts/validate-design-system.ts",
    "test:i18n": "npx nx test consumer-portal --testPathPattern=i18n.spec.ts",
    "generate:context": "npx repomix",
    "test:watch": "nx affected --target=test --watch --parallel=3",
    "lint:watch": "nx affected --target=lint --watch --parallel=3",
    "test:coverage": "nx run-many --target=test --configuration=coverage --parallel=3",
    "generate:embeddings": "tsx scripts/generate-embeddings.ts",
    "search": "tsx scripts/semantic-search.ts",
    "bdd:generate": "cd apps/consumer-portal-e2e && npx bddgen",
    "bdd:test": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules --project=authentication --project=servicing --project=origination --project=marketing --project=jv-theme --project=origination-ui --project=purchase-application --project=refinance-application",
    "bdd:test:ui": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules --project=authentication --project=servicing --project=origination --project=marketing --project=jv-theme --project=origination-ui --project=purchase-application --project=refinance-application --ui",
    "bdd:test:debug": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules --project=authentication --project=servicing --project=origination --project=marketing --project=jv-theme --project=origination-ui --project=purchase-application --project=refinance-application --debug",
    "bdd:test:headed": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules --project=authentication --project=servicing --project=origination --project=marketing --project=jv-theme --project=origination-ui --project=purchase-application --project=refinance-application --headed",
    "bdd:report": "open dist/.playwright/apps/consumer-portal-e2e/cucumber-report.html",
    "bdd:business-rules": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules",
    "bdd:business-rules:headed": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules --headed",
    "bdd:business-rules:debug": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=business-rules --debug",
    "bdd:authentication": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=authentication",
    "bdd:servicing": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=servicing",
    "bdd:origination": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=origination",
    "bdd:marketing": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=marketing",
    "bdd:jv-theme": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=jv-theme",
    "bdd:origination-ui": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=origination-ui",
    "bdd:purchase-application": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=purchase-application",
    "bdd:refinance-application": "npm run bdd:generate && npx playwright test --config apps/consumer-portal-e2e/playwright.config.ts --project=refinance-application"
  },
  "lint-staged": {
    "*.{ts,tsx}": [
      "eslint --fix --max-warnings=0"
    ],
    "*.{json,md,html,scss,css}": [
      "prettier --write"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.12",
    "@angular/cdk": "21.2.10",
    "@angular/common": "21.2.12",
    "@angular/compiler": "21.2.12",
    "@angular/core": "21.2.12",
    "@angular/forms": "21.2.12",
    "@angular/material": "21.2.10",
    "@angular/platform-browser": "21.2.12",
    "@angular/platform-browser-dynamic": "21.2.12",
    "@angular/router": "21.2.12",
    "@azure/msal-angular": "4.0.25",
    "@azure/msal-browser": "4.28.1",
    "@capacitor-community/date-picker": "7.1.0",
    "@capacitor-community/generic-oauth2": "7.0.0",
    "@capacitor-firebase/analytics": "8.0.1",
    "@capacitor-firebase/crashlytics": "8.0.1",
    "@capacitor/android": "8.0.2",
    "@capacitor/app": "8.0.0",
    "@capacitor/browser": "8.0.0",
    "@capacitor/cli": "8.0.2",
    "@capacitor/clipboard": "8.0.0",
    "@capacitor/core": "8.0.2",
    "@capacitor/device": "8.0.0",
    "@capacitor/dialog": "8.0.0",
    "@capacitor/file-viewer": "2.0.0",
    "@capacitor/filesystem": "8.1.0",
    "@capacitor/haptics": "8.0.0",
    "@capacitor/ios": "8.0.2",
    "@capacitor/keyboard": "8.0.0",
    "@capacitor/local-notifications": "^8.2.0",
    "@capacitor/network": "8.0.0",
    "@capacitor/preferences": "8.0.0",
    "@capacitor/push-notifications": "8.0.0",
    "@capacitor/share": "8.0.0",
    "@capacitor/splash-screen": "8.0.0",
    "@capacitor/status-bar": "8.0.0",
    "@capgo/capacitor-in-app-review": "8.1.2",
    "@capgo/capacitor-native-biometric": "^8.4.5",
    "@capgo/capacitor-updater": "8.43.10",
    "@jsverse/transloco": "8.2.1",
    "@microsoft/applicationinsights-web": "3.3.11",
    "driver.js": "1.4.0",
    "firebase": "12.8.0",
    "gridstack": "12.6.0",
    "jspdf": "3.0.4",
    "postcss": "8.5.6",
    "rxjs": "7.8.2",
    "tailwindcss": "4.1.18",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "21.2.10",
    "@angular-devkit/schematics": "21.2.10",
    "@angular/build": "21.2.10",
    "@angular/cli": "21.2.10",
    "@angular/compiler-cli": "21.2.12",
    "@angular/language-service": "21.2.12",
    "@capacitor-firebase/remote-config": "8.0.1",
    "@commitlint/cli": "19.8.1",
    "@commitlint/config-conventional": "19.8.1",
    "@cucumber/cucumber": "10.9.0",
    "@cucumber/cucumber-expressions": "17.1.0",
    "@cucumber/gherkin": "27.0.0",
    "@eslint/js": "9.39.2",
    "@nx/angular": "22.4.4",
    "@nx/devkit": "22.4.4",
    "@nx/eslint": "22.4.4",
    "@nx/eslint-plugin": "22.4.4",
    "@nx/jest": "22.4.4",
    "@nx/js": "22.4.4",
    "@nx/playwright": "22.4.4",
    "@nx/web": "22.4.4",
    "@nx/workspace": "22.4.4",
    "@playwright/test": "1.58.1",
    "@schematics/angular": "21.1.2",
    "@swc-node/register": "1.9.2",
    "@swc/core": "1.5.29",
    "@swc/helpers": "0.5.18",
    "@tailwindcss/postcss": "4.1.18",
    "@types/google.maps": "3.58.1",
    "@types/jest": "29.5.14",
    "@types/node": "20.19.9",
    "@types/pdfmake": "0.2.13",
    "@typescript-eslint/parser": "8.54.0",
    "@typescript-eslint/typescript-estree": "8.54.0",
    "@typescript-eslint/utils": "8.54.0",
    "agent-browser": "0.26.0",
    "angular-eslint": "21.2.0",
    "angular-estree-parser": "15.4.3",
    "baseline-browser-mapping": "2.9.19",
    "cross-env": "10.1.0",
    "eslint": "9.39.2",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-playwright": "1.8.3",
    "firebase-admin": "13.7.0",
    "husky": "9.1.7",
    "jest": "30.2.0",
    "jest-environment-jsdom": "30.2.0",
    "jest-environment-node": "30.2.0",
    "jest-preset-angular": "16.0.0",
    "jest-util": "30.2.0",
    "jsonc-eslint-parser": "2.4.2",
    "lint-staged": "16.2.7",
    "nx": "22.4.4",
    "playwright": "1.58.1",
    "playwright-bdd": "7.5.0",
    "prettier": "3.8.1",
    "ts-jest": "29.4.6",
    "ts-node": "10.9.1",
    "tslib": "2.8.1",
    "tsx": "4.21.0",
    "typescript": "5.9.3",
    "typescript-eslint": "8.54.0"
  }
}
